import { useEffect, useState } from 'react';
import type { OperationDoc, OperationStatus } from '@asm/shared';

const STALE_AI_OPERATION_MS = 9.5 * 60_000;

/** A timed-out callable cannot update its operation document, so stop showing it as live. */
export function isStaleAiOperation(operation: OperationDoc, now = Date.now()): boolean {
  return operation.type === 'ai-translate'
    && operation.status === 'running'
    && now - operation.startedAt.toMillis() >= STALE_AI_OPERATION_MS;
}

export function visibleOperationStatus(operation: OperationDoc, now = Date.now()): OperationStatus {
  return isStaleAiOperation(operation, now) ? 'error' : operation.status;
}

/** Re-evaluate abandoned operations even when their Firestore document never changes. */
export function useActivityNow(): number {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const interval = window.setInterval(() => setNow(Date.now()), 30_000);
    return () => window.clearInterval(interval);
  }, []);
  return now;
}

export const STALE_AI_OPERATION_MESSAGE = 'The AI run exceeded its time limit. Retry it; completed drafts remain saved.';
